import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {UndoRedoButtonsProps} from './undo-redo-buttons.types';

export function UndoRedoButtons({actions, canUndo, canRedo}: UndoRedoButtonsProps): ReactElement {
  return (
    <>
      <Icon
        icon="icon-undo"
        shape={IconShape.SQUARE}
        type={IconType.DARK_GHOST}
        size={IconSize.SIZE_ICON_24}
        isDisabled={!canUndo}
        ariaLabel={window.i18next.t('pmwjs_undo')}
        onClick={(): void => {
          actions.undo();
        }}
      />
      <Icon
        icon="icon-redo"
        shape={IconShape.SQUARE}
        type={IconType.DARK_GHOST}
        size={IconSize.SIZE_ICON_24}
        isDisabled={!canRedo}
        ariaLabel={window.i18next.t('pmwjs_redo')}
        onClick={(): void => {
          actions.redo();
        }}
      />
    </>
  );
}
